import React, { Suspense, useEffect, useRef } from 'react'
import { Redirect, Route, Switch, useLocation } from 'react-router-dom'
import { Card, Skeleton } from 'antd'
import moment from 'moment'

import ManageAside from './ManageAside'
import { IBreadcrumb } from '@/components'
import { applyWatermark, getFirstRoutePath } from '@/utils/util'
import { useAppSelector } from '@/utils/hooks'
import { layoutConfig } from '@/utils/consts'

interface Props {
  route: Routes[number]
  routes: Routes
}

const ManageLayout: React.FC<Props> = ({ route, routes, ...rest }) => {
  const { userInfo, uiConfig } = useAppSelector(state => state.app)
  const watermarkRef = useRef(null)
  const location = useLocation()
  const firstPath = getFirstRoutePath(routes)
  const redirectPath = !firstPath || firstPath === '*' ? '/notFound' : firstPath

  // 只在访问根路径时才需要重定向,避免无限循环
  const shouldRedirect = location.pathname === route?.path

  useEffect(() => {
    if (userInfo.userId && watermarkRef.current) {
      const { userAccount, ip } = userInfo
      const date = moment().format('YY/M/D')
      const text = `${userAccount} IP ${ip} ${date}`
      applyWatermark(watermarkRef.current, text, {
        color: 'rgba(0, 0, 0, 0.06)',
        fontSize: '24px',
        angle: -20,
        width: 684,
        height: 400,
      })
    }
  }, [userInfo, watermarkRef])

  const renderRoutes = (routes: Routes): React.ReactNode => {
    if (!routes?.length) {
      return null
    }
    return routes.map(route =>
      route.component ? (
        <Route exact={true} key={route.path} path={route.path}>
          <route.component {...rest}>{route.routes && renderRoutes(route.routes)}</route.component>
        </Route>
      ) : (
        route.routes && renderRoutes(route.routes)
      )
    )
  }

  return (
    <div className="manage-layout">
      <div className="water-mark" ref={watermarkRef}></div>
      {uiConfig.menuBarLayout === layoutConfig.top && <ManageAside routes={routes}></ManageAside>}
      <div className="manage-layout-main">
        {uiConfig.menuBarLayout === layoutConfig.top && <IBreadcrumb route={route}></IBreadcrumb>}
        <Suspense fallback={<Skeleton active></Skeleton>}>
          <div
            style={{
              padding: uiConfig.menuBarLayout === layoutConfig.side ? '0 24px 100px' : '0 24px',
            }}
          >
            <Card className="manage-layout-main-card">
              <Switch>
                {shouldRedirect && <Redirect exact from={route?.path} to={redirectPath} />}
                {renderRoutes(routes)}
              </Switch>
            </Card>
          </div>
        </Suspense>
      </div>
    </div>
  )
}

export default ManageLayout
